
<template>
    <a-select :value="passwaytype" placeholder=""  style="width: 150px"
            :default-active-first-option="true" :not-found-content="null" :disabled="isdisable"
            @change="handleChange">
        <a-select-option v-for="d in passwaytypes" :key="d.passwaytype">
            {{ d.passwaytypename }}
        </a-select-option>
    </a-select>
</template>
<script>
export default {
    data() {
        return {
            passwaytypes: [],
            passwaytype:'',
        }
    },
    props:{
        showAll:Boolean,
        isdisable:Boolean
    },
    methods: {
        handleChange(v) {
            this.passwaytype = v;
            let targetData = this.passwaytypes.filter((item) => {
                return item.passwaytype == v
            });
            if (targetData.length > 0) {
                this.$emit('passwayTypeChange', targetData[0]);
            }
        },
        doSearch() {
            let that = this;
            let c_params = {
                urlparams: false,
            }

            that.$store.dispatch({
                type: "mcmsmanager/querypasswaytypes",
                params: c_params,
                showMsg: false
            }).then((res) => {
                if (res.data.success == 1) {
                    if(that.showAll){
                        that.passwaytypes = [
                            {
                                passwaytype:'',
                                passwaytypename:'全部',
                                id:'-1'
                            }
                        ];
                    }
                    else{
                        that.passwaytypes = [];
                    }
                    let result = res.data.data;
                    if(!result || result.length == 0){
                        that.message.error("未查到通道类型");
                        return;
                    }
                    result = result.sort((a,b) => { return parseInt(a.id) > parseInt(b.id) ? 1 : -1 })
                    result.forEach(r => {
                        that.passwaytypes.push({
                            passwaytype: r.passwaytype,
                            passwaytypename: r.passwaytypename,
                        });
                    });
                    if(that.passwaytypes.length > 0){
                        that.passwaytype = that.passwaytypes[0].passwaytype
                        that.handleChange(that.passwaytypes[0].passwaytype)
                    }
                    this.$store.commit({
                        type: 'mcmsmanager/save',
                        payload: {
                            passwayTypeList: result
                        }
                    })
                }
            }).catch(() => {

            });
        },
    },
    mounted(){
        this.doSearch();
    },
};
</script>

<style scoped>

</style>
